/* @flow */
import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Paper,
    Toolbar,
    Typography,
    IconButton,
    Button,
} from '@mui/material';
import MiniDrawer from '../../components/SideMenu/SideMenuDrawer';
import AppLoader from '../../components/AppLoader';
import FleetioConfig from './FleetioConfig';
import FleetioAssetList from './FleetioAssetList';
import FleetioAssetSyncConfig from './FleetioAssetSyncConfig';
import HelpButton from '../../components/SharedComponents/HelpButton/HelpButton';
import { getFleetioAccount } from './helper-classes/fleetio-services';
import { FLEETIO_MESSAGES } from './constants.fleetio';
import backIcon from '../../assets/icons/back.png';
import styles from './Fleetio.module.scss';

export type Props = {
    history: {
        push: Function,
    },
};

export type State = {
    initialLoading: boolean,
    connected: boolean,
    editing: boolean,
    selectedAsset: ?Object,
};

class Fleetio extends React.Component<Props, State> {
    state = {
        initialLoading: true,
        connected: false,
        editing: false,
        selectedAsset: null,
    };

    componentDidMount() {
        this.checkConnection();
    }

    checkConnection = () => {
        getFleetioAccount()
            .then((data) => {
                this.setState({ initialLoading: false, connected: !!data });
            });
    }

    handleConnectSuccess = () => {
        this.setState({ connected: true, editing: false });
    }

    handleEditCancel = () => {
        this.setState({ editing: false });
    }

    handleEditAssetSync = (asset: Object) => {
        this.setState({ selectedAsset: asset });
    }

    handleAssetSyncCancel = () => {
        this.setState({ selectedAsset: null });
    }

    handleAssetSyncSuccess = () => {
        this.setState({ selectedAsset: null });
    }

    renderConnectedView() {
        const { history } = this.props;
        const { selectedAsset } = this.state;

        if (selectedAsset) {
            return (
                <FleetioAssetSyncConfig
                    asset={selectedAsset}
                    onCancel={this.handleAssetSyncCancel}
                    onSuccess={this.handleAssetSyncSuccess}
                />
            );
        }

        return (
            <div className={styles.app}>
                <Paper>
                    <Toolbar className={styles.toolbar}>
                        <span className={styles.backButton}>
                            <IconButton
                                onClick={() => history.push('/integrations')}
                                size="large"
                            >
                                <img src={backIcon} alt="backArrow" />
                            </IconButton>
                        </span>
                        <Typography
                            variant="h6"
                            color="inherit"
                            className={styles.titleWrap}
                        >
                            Fleetio Integration
                        </Typography>
                    </Toolbar>
                    <div className={styles.contentHeader}>
                        <div className={styles.statusRow}>
                            <Typography variant="h6" className={styles.statusLabel}>
                                Status:
                            </Typography>
                            <span className={styles.connectedGroup}>
                                <Typography variant="h6" className={styles.connectedText}>
                                    Connected
                                </Typography>
                                <HelpButton
                                    type="assetSync"
                                    helpText={FLEETIO_MESSAGES.ASSET_SYNC_HELPER}
                                />
                            </span>
                            <Button
                                className={styles.editButton}
                                onClick={() => this.setState({ editing: true })}
                            >
                                EDIT
                            </Button>
                        </div>
                    </div>
                    <FleetioAssetList
                        tableRootClass={styles.tableRoot}
                        onEditAssetSync={this.handleEditAssetSync}
                    />
                </Paper>
            </div>
        );
    }

    render() {
        const { history } = this.props;
        const { initialLoading, connected, editing } = this.state;

        return (
            <MiniDrawer redirectTo={history.push}>
                {initialLoading && <AppLoader type="fullScreen" fullScreenStyle={{ background: 'transparent' }} />}
                {!initialLoading && connected && !editing && this.renderConnectedView()}
                {!initialLoading && (!connected || editing) && (
                    <FleetioConfig
                        onSuccess={this.handleConnectSuccess}
                        onCancel={connected ? this.handleEditCancel : null}
                        isEdit={editing}
                    />
                )}
            </MiniDrawer>
        );
    }
}

export default withRouter(Fleetio);
